import { Breadcrumb, Card } from 'nhsuk-react-components';
import ActivityCentre from 'components/ActivityCentre/ActivityCentre';

function ActivityPage() {
  return (
    <>
      <div className="nhsuk-u-margin-bottom-6">
        <Breadcrumb>
          <Breadcrumb.Item href="/">
            Home
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <span aria-current="page">Activity centre</span>
          </Breadcrumb.Item>
        </Breadcrumb>
      </div>
      <Card>
        <main id="maincontent">
          <h2>Activity centre</h2>
          <p>This page shows your notifications across your teams.</p>
          <p>Notifications will expire after 14 days and be removed from your activity centre.</p>
        </main>
      </Card>

      <Card>
        <ActivityCentre />
      </Card>
    </>
  );
}

export default ActivityPage;
